import React, { FunctionComponent, useEffect } from 'react'

import { shallowEqual } from 'react-redux'
import { Navigate } from 'react-router-dom'

import { Spinner } from '@fairhq/common'

import { useGetEntitlementsQuery } from 'store/company/companyApiWithQuery'
import { EntitlementsEnum } from 'store/company/types'
import { useAppSelector } from 'store/hooks'
import { State } from 'store/state'

export const Home: FunctionComponent = () => {
  const { companyId } = useAppSelector(
    (state: State) => ({
      companyId: state.apiHeadersReducer.companyId,
    }),
    shallowEqual
  )

  const {
    data: companyEntitlements,
    isFetching,
    isSuccess,
    refetch,
  } = useGetEntitlementsQuery()

  useEffect(() => {
    if (
      companyId &&
      !isFetching &&
      companyEntitlements?.entitlements?.length === 0
    ) {
      refetch()
    }
  }, [companyEntitlements, companyId, isFetching, refetch])

  if (
    isSuccess &&
    companyEntitlements?.entitlements.includes(EntitlementsEnum.STRATEGY)
  ) {
    return <Navigate to="/strategy" />
  }

  if (
    isSuccess &&
    companyEntitlements?.entitlements.includes(
      EntitlementsEnum.ADVANCED_ASSESSMENT_AUDIT
    )
  ) {
    return <Navigate to="/equality" />
  }

  if (
    isSuccess &&
    companyEntitlements?.entitlements.includes(EntitlementsEnum.SURVEYS)
  ) {
    return <Navigate to="/survey" />
  }

  return <Spinner center />
}
